export type AiArticleType = 'headline' | 'tw_stock' | 'us_stock';

type AiArticleSource = 'US_Stock_Summary' | 'TW_Stock_Summary' | 'Headline_Summary';

export type GETv1AiArticlesResponse = {
  source: AiArticleSource;
  summary: string;
  created_at: number;
  related: RelativeNews;
  title: string;
};

export type GETv1AiArticlesReturnResponse = {
  source: AiArticleSource;
  summary: string;
  createdAt: number;
  related: RelativeNews;
  title: string;
};

export const DEFAULT_AI_CONTENT = {
  title: '',
  summary: '',
  source: 'US_Stock_Summary' as AiArticleSource,
  createdAt: 0,
  related: []
};

export type ResponseAiArticleType = {
  items: GETv1AiArticlesResponse;
  message: string;
  statusCode: number;
};

export type RelativeNews = Pick<News, 'title' | 'newsId'>[];

export const AI_TABS: { category: AiArticleType; name: string }[] = [
  { category: 'headline', name: '頭條' },
  { category: 'tw_stock', name: '台股' },
  { category: 'us_stock', name: '美股' }
];
